<template>
  <NavNuxtLink
    :data-testId="`${item.name}-nav-link`"
    :to="item.to"
    :class="[
      small ? 'text-sm' : 'text-base',
      sectionIcon ? 'gap-2 pl-3' : 'pl-7',
      'group flex w-full cursor-pointer items-center border-b border-fp-green-7/20 py-2 pr-2 text-white transition-colors last:border-b-0',
      !isSidebarNavActive && 'hover:bg-fp-green-7/20',
    ]"
  >
    <component
      :is="sectionIcon"
      v-if="sectionIcon"
      class="h-4 w-4 shrink-0 opacity-75"
      aria-hidden="true"
    />
    <span class="inline-flex min-w-0 max-w-full flex-1 items-center gap-1.5">
      <span class="truncate">{{ item.name }}</span>
      <span class="admin-sidebar__hover-arrow shrink-0" aria-hidden="true">
        <ArrowRightIcon class="h-4 w-4 shrink-0" />
      </span>
    </span>
  </NavNuxtLink>
</template>

<script lang="ts" setup>
import type { Component, PropType } from 'vue'
import { ArrowRightIcon } from '@heroicons/vue/24/outline'
import type { MenuItem } from '~/models/menu-item'
import NavNuxtLink from '~~/components/navigation/NavNuxtLink'

const props = defineProps({
  item: {
    type: Object as PropType<MenuItem>,
    required: true,
  },
  small: {
    type: Boolean,
    default: false,
  },
  sectionIcon: {
    type: Object as PropType<Component | undefined>,
    default: undefined,
  },
})

const { isActive, isExactActive } = useLink({
  to: computed(() => props.item.to),
})
const isSidebarNavActive = computed(() => isActive.value || isExactActive.value)
</script>
